module.exports = __webpack_public_path__ + "static/img/wisdom7.20f021a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/wisdom7.png
// module id = 6NV7
// module chunks = 1